(function () {
    'use strict';
    var m = angular.module('common');
    m.factory('metaInfoConverter', ["beautifyKey", "$filter", "limitedArrayConverter", function (beautifyKey, $filter, limitedArrayConverter) {
        function buildData(input, args) {
            /*
        * input: object. it includes 2 object data.
        * input.originData: main data to parse
        * input.entityInfo: support data for main data
        *
        * */
            function convertKey(key) {
                if (args.niceKeyLabels && args.niceKeyLabels[key]) {
                    return args.niceKeyLabels[key];
                }
                if (input.entityInfo && input.entityInfo[key] && input.entityInfo[key].label) {
                    return input.entityInfo[key].label;
                }
                if (args.beautifyKey) {
                    return beautifyKey(key);
                }
                return key;
            }
            function convertValue(value, key) {
                if (input.entityInfo && input.entityInfo[key] && input.entityInfo[key].value_type === 'DATETIME') {
                    value = moment.utc(value).local().format('YYYY-MM-DD HH:mm:ss');
                }
                if (input.entityInfo && input.entityInfo[key] && input.entityInfo[key].options) {
                    var found = _(input.entityInfo[key].options).find(function (option) {
                        return option.id === value;
                    });
                    if (found) {
                        return found.label;
                    }
                }
                if (input.entityInfo && input.entityInfo[key] && input.entityInfo[key].show_as_bytes) {
                    return $filter('bytes')(value, 1, true);
                }
                if (_(value).isObject() || _(value).isNull()) {
                    return JSON.stringify(value);
                }
                if (/^https?:\/\//.test(value)) {
                    return '#' + JSON.stringify({
                        display: 'external-link',
                        href: value,
                        text: value
                    });
                }
                if (args.whiteList) {
                    var foundKey = _(args.whiteList).find(function (prop) {
                        return _(prop).isObject() && prop.key === key && prop.type === 'resolver';
                    });
                    if (foundKey) {
                        return '#' + JSON.stringify({
                            display: 'link',
                            type: 'profile',
                            id: value,
                            entityType: foundKey.resolverEntity,
                            text: input.resolvers && input.resolvers[key] && input.resolvers[key][foundKey.resolverKey] || value
                        });
                    }
                    var foundEnternalKey = _(args.whiteList).find(function (prop) {
                        return _(prop).isObject() && prop.key === key && prop.type === 'external';
                    });
                    if (foundEnternalKey) {
                        if (foundEnternalKey.valueFormat === 'list') {
                            var arrayData = _(input.external && input.external[key]).map(function (obj) {
                                return '#' + JSON.stringify({
                                    display: 'link',
                                    type: 'profile',
                                    id: obj.entity_id,
                                    entityType: foundEnternalKey.externalEntity,
                                    text: obj[foundEnternalKey.externalKey]
                                });
                            });
                            return limitedArrayConverter(arrayData, foundEnternalKey.args);
                        } else {
                            return '#' + JSON.stringify({
                                display: 'link',
                                type: 'profile',
                                id: input.external && input.external[key].entity_id,
                                entityType: foundEnternalKey.externalEntity,
                                text: input.external && input.external[key][foundEnternalKey.externalKey]
                            });
                        }
                    }
                }
                return $filter('localTimeIfIsoString')(value);
            }
            function pairVisible(advanced, key, value) {
                if (!(args.whiteList && args.whiteList.length) && !(args.blackList && args.blackList.length)) {
                    return true;
                }
                if (args.whiteList) {
                    if (_(args.whiteList).findIndex(function (prop) {
                            if (_(prop).isObject() && prop.key === key) {
                                return !(prop.hiddenPairAny && prop.hiddenPairAny.value === value);
                            }
                            if (_(prop).isString()) {
                                return prop === key;
                            }
                            return false;
                        }) !== -1) {
                        return true;
                    }
                }
                return false;
            }
            var advanced = true;
            if (!args.advancedModeEnabled) {
                advanced = false;
            }
            var data = _(input.originData).map(function (value, key) {
                return {
                    key: key,
                    value: value
                };
            });
            if (args.ordering === 'key') {
                data = _(data).sortBy('key');
            } else if (input.entityInfo && (args.ordering === 'entityOrder' || args.ordering === 'widgetViewOrder' || args.autoWidgetEnabled)) {
                var sortField = args.ordering === 'widgetViewOrder' ? 'widget_view_order' : 'order';
                data = _(data).chain().sortBy(function (dataEl) {
                    return input.entityInfo[dataEl.key] && input.entityInfo[dataEl.key].label || 'zzzzzzz';
                }).sortBy(function (dataEl) {
                    return parseInt(input.entityInfo[dataEl.key] && input.entityInfo[dataEl.key][sortField]) || 0;
                }).sortBy(function (dataEl) {
                    return isFinite(parseInt(input.entityInfo[dataEl.key] && input.entityInfo[dataEl.key][sortField])) ? 0 : 1;
                }).value();
            }
            var pairs = _(data).reduce(function (memo, dataEl) {
                var key = dataEl.key;
                var value = dataEl.value;
                if (pairVisible(advanced, key, value)) {
                    var itemClass = {};
                    itemClass['info-field-' + key] = true;
                    if (args.expandMap && args.expandMap[key] && _(value).isObject()) {
                        _(value).each(function (mapValue, mapKey) {
                            memo.push({
                                class: itemClass,
                                key: convertKey(key + ' ' + mapKey),
                                value: $filter('localTimeIfIsoString')(mapValue)
                            });
                        });
                        return memo;
                    } else {
                        memo.push({
                            class: itemClass,
                            key: convertKey(key),
                            value: convertValue(value, key)
                        });
                    }
                }
                return memo;
            }, []);
            if (args.buttons) {
                var buttons = _(args.buttons).filter(function (button) {
                    return (advanced || !button.advanced) && button.label;
                });
                if (buttons.length) {
                    pairs.push({ buttons: buttons });
                }
            }
            return pairs;
        }
        return function (input, args) {
            return buildData(input, args);
        };
    }]);
}());